import React, { Component } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { SideNav } from './'
import PageWithSidebar from 'components/PageWithSidebar'
import { isAdmin } from 'services/self'

import RegisteredAccounts from 'pages/Admin/Accounts/RegisteredAccounts'
import AdminAccounts from 'pages/Admin/Accounts/AdminAccounts'
import PendingInvites from 'pages/Admin/Accounts/PendingInvites'
import ApiThrottling from 'pages/Admin/Accounts/ApiThrottling'
import ClientBoarding from 'pages/Admin/ClientOnboarding'

export class Admin extends Component {
  render () {
    const admin = isAdmin()

    return (
      <PageWithSidebar sidebarContent={<SideNav />}>
        <>
          <Routes>
            <Route index element={<Navigate to='accounts' />} />
            <Route path='accounts' element={admin ? <RegisteredAccounts /> : <Navigate to='/' />} />
            <Route path='accounts/admins' element={admin ? <AdminAccounts /> : <Navigate to='/' />} />
            <Route path='accounts/invites' element={admin ? <PendingInvites /> : <Navigate to='/' />} />
            <Route path='api-management' element={admin ? <ApiThrottling /> : <Navigate to='/' />} />
            <Route path='client-management' element={admin ? <ClientBoarding /> : <Navigate to='/' />} />
          </Routes>
        </>
      </PageWithSidebar>
    )
  }
}
